import { gozokiApiWithAuth } from '../gozokiApi'
import type { DocumentItem, StoreProjectApiStatus } from '../queries/storeProjects.queries'

// Update store project position (handles both status and position changes)
export const updateStoreProjectPosition = async ({
  id,
  status,
  position,
}: {
  id: string
  status: StoreProjectApiStatus
  position: number
}) => {
  const response = await gozokiApiWithAuth.patch<{
    id: string
    status: string
    displayOrder: number
  }>(`/store-projects/${id}/position`, { status, position })
  return response.data
}

// Upload photo for a store project
export const uploadStoreProjectPhoto = async ({ id, photo }: { id: string; photo: File }) => {
  const formData = new FormData()
  formData.append('photo', photo)

  const response = await gozokiApiWithAuth.post<{ url: string; photoUrls: string[] }>(
    `/store-projects/${id}/upload-photo`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  )
  return response.data
}
// Delete photo from a store project
export const deleteStoreProjectPhoto = async ({
  id,
  photoUrl,
}: {
  id: string
  photoUrl: string
}) => {
  const response = await gozokiApiWithAuth.delete<{ success: boolean; photoUrls: string[] }>(
    `/store-projects/${id}/delete-photo`,
    {
      data: { photoUrl },
    },
  )
  return response.data
}

// Upload document for a store project
export const uploadStoreProjectDocument = async ({
  id,
  document,
}: {
  id: string
  document: File
}) => {
  const formData = new FormData()
  formData.append('document', document)

  const response = await gozokiApiWithAuth.post<{
    document: DocumentItem
    documents: DocumentItem[]
  }>(`/store-projects/${id}/upload-document`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  return response.data
}

// Delete document from a store project
export const deleteStoreProjectDocument = async ({
  id,
  documentUrl,
}: {
  id: string
  documentUrl: string
}) => {
  const response = await gozokiApiWithAuth.delete<{
    success: boolean
    documents: DocumentItem[]
  }>(`/store-projects/${id}/delete-document`, {
    data: { documentUrl },
  })
  return response.data
}

// Rename document in a store project
export const renameStoreProjectDocument = async ({
  id,
  documentUrl,
  newName,
}: {
  id: string
  documentUrl: string
  newName: string
}) => {
  const response = await gozokiApiWithAuth.patch<{
    success: boolean
    documents: DocumentItem[]
  }>(`/store-projects/${id}/rename-document`, {
    documentUrl,
    newName,
  })
  return response.data
}
